import { useState } from 'react';
import { faqData } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-primary-600 font-medium tracking-wide uppercase mb-2">
            常见问题
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            你可能会问
          </h2>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}